import { render, staticRenderFns } from "./LocationAdministrationOverview.vue?vue&type=template&id=08650d75&scoped=true&"
import script from "./LocationAdministrationOverview.vue?vue&type=script&lang=js&"
export * from "./LocationAdministrationOverview.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdministrationOverview.vue?vue&type=style&index=0&id=08650d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08650d75",
  null
  
)

/* custom blocks */
import block0 from "./LocationAdministrationOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08650d75')) {
      api.createRecord('08650d75', component.options)
    } else {
      api.reload('08650d75', component.options)
    }
    module.hot.accept("./LocationAdministrationOverview.vue?vue&type=template&id=08650d75&scoped=true&", function () {
      api.rerender('08650d75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/location-administration/LocationAdministrationOverview.vue"
export default component.exports